import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { EpinClaimSuccessComponent } from './epin-claim-success.component';
import { SmallToCryptoPipeModule } from '../../angular-wallet-base/pipes/smalltocrypto/smalltocrypto.module';
import { CustomCurrencyPipeModule } from '../../angular-wallet-base/pipes/customcurrency/customcurrency.module';

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        TranslateModule,
        SmallToCryptoPipeModule,
        CustomCurrencyPipeModule
    ],
    declarations: [EpinClaimSuccessComponent]
})
export class EpinClaimSuccessModule { }
